
import React from 'react';

/**
 * CookieConsentBanner - Completely optimized null-rendering component
 * Uses React.memo with a custom comparison function that always returns true
 * to ensure the component is never re-rendered
 */
const CookieConsentBanner = React.memo(
  () => null,
  () => true // Custom comparison that always returns true, preventing any re-renders
);

// Add display name for debugging
CookieConsentBanner.displayName = 'CookieConsentBanner';

export default CookieConsentBanner;
